import { LOCATIONS } from "./locations";

export const NAV = [
  { label: "LVP Flooring", href: "/flooring/luxury-vinyl-plank" },
  { label: "LVP Installation", href: "/installation" },
  { label: "Products", href: "/products" },
  { label: "Homeowners", href: "/homeowners" },
  {
    label: "Contractors",
    href: "/contractors",
    mega: "contractors",
    items: [
      { label: "Contractor Flooring", href: "/contractors/contractor-flooring" },
      { label: "Builder Flooring", href: "/contractors/builder-flooring" },
      { label: "Flooring Delivery", href: "/contractors/flooring-delivery" },
      { label: "Volume Pricing", href: "/contractors/volume-pricing" },
    ],
    audiences: [
      { label: "General Contractors", href: "/contractors/general-contractors" },
      { label: "Home Builders", href: "/contractors/home-builders" },
      { label: "Remodelers", href: "/contractors/remodelers" },
      { label: "Property Managers", href: "/contractors/property-managers" },
      { label: "Real Estate Investors", href: "/contractors/real-estate-investors" },
      { label: "Flooring Installers", href: "/contractors/flooring-installers" },
    ],
  },
  {
    label: "Service Areas",
    href: "/service-areas",
    mega: "areas",
    items: LOCATIONS.map((l) => ({ label: `${l.name}, NC`, href: `/service-areas/${l.slug}`, contractor: `/service-areas/${l.slug}/contractors` })),
  },
  { label: "Gallery", href: "/gallery" },
  { label: "About", href: "/about" },
  { label: "FAQ", href: "/faq" },
  { label: "Contact", href: "/contact" },
];
